module.exports = __webpack_public_path__ + "img/900258798.faa77720.png";